<template>
  <v-container fluid>
    <v-layout row wrap align-center justify-center fill-height>
      <v-flex lg12>
        <v-card class="statics-filters liquidation-report-filters">
          <v-card-text class="pt-2 pb-2">
            <v-layout row wrap align-end>
              <v-flex xs12 sm6 md2>
                <v-text-field
                  label="Liquidación"
                  :clearable="true"
                  v-model="filters.liquidacion"
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-text-field
                  label="Recibo"
                  :clearable="true"
                  v-model="filters.recibo"
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-text-field
                  label="Póliza"
                  :clearable="true"
                  v-model="filters.poliza"
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-text-field
                  label="Identificación"
                  :clearable="true"
                  v-model="filters.identificacion"
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-text-field
                  label="Contrato"
                  :clearable="true"
                  v-model="filters.contrato"
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap align-end class="mt-3">
              <v-flex xs12 sm6 md2>
                <v-select
                  :items="estados"
                  item-value="id"
                  item-text="name"
                  autocomplete
                  label="Estado"
                  v-model="filters.estado"
                  :clearable="true"
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-select
                  :items="fuentes"
                  item-value="id"
                  item-text="name"
                  autocomplete
                  label="Sistema"
                  v-model="filters.sistema"
                  :clearable="true"
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-text-field
                  label="Fecha inicio (pago)"
                  :clearable="true"
                  v-model="filters.fechaInicio"
                  type="date"
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-text-field
                  label="Fecha final (pago)"
                  :clearable="true"
                  v-model="filters.fechaFin"
                  type="date"
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4 class="liquidation-report-actions">
                <div class="liquidation-report-actions-inner">
                  <v-text-field
                    v-model="filters.buscar"
                    label="Buscar"
                    placeholder="Buscar"
                    single-line
                    hide-details
                    class="liquidation-report-buscar"
                    @keyup.enter="search()"
                  ></v-text-field>
                  <v-btn
                    class="grey lighten-2 liquidation-report-btn"
                    small
                    @click="search()"
                  >
                    Filtrar
                  </v-btn>
                  <v-btn
                    class="grey lighten-2 liquidation-report-btn"
                    small
                    @click="limpiar()"
                  >
                    Limpiar
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-divider style="margin:0px"></v-divider>
      <v-flex lg12>
        <v-card>
          <v-card-text class="row pt-1">
            <liquidation-comission-list
              :items="commissionReport"
            ></liquidation-comission-list>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import moment from "moment";
import LiquidationComissionList from "./LiquidationComissionList";

export default {
  computed: {
    ...mapGetters([
      "loadingCommission",
      "commissionReport",
      "agency",
      "estados",
      "fuentes"
    ])
  },
  mounted() {
    this.$store.dispatch("estados");
    this.$store.dispatch("fuentes");
    this.applyDefaultPayDates();
    this.$store.dispatch("getCommissionsReport", this.filters);
  },
  methods: {
    nzDate: nzDate,
    applyDefaultPayDates() {
      this.filters.fechaInicio = moment()
        .subtract(2, "months")
        .format("YYYY-MM-DD");
      this.filters.fechaFin = moment().format("YYYY-MM-DD");
    },
    emptyFilters() {
      return {
        agente: "",
        agencia: "0",
        estado: "0",
        fechaInicio: null,
        fechaFin: null,
        liquidacion: null,
        recibo: null,
        poliza: null,
        sistema: null,
        identificacion: null,
        contrato: null,
        buscar: ""
      };
    },
    uniqueCheck(e, index) {
      for (let i = 0; i < this.selectRow.length; i++) {
        if (index != i) {
          this.selectRow[i] = false;
        }
      }
      if (!this.selectRow[index]) {
        this.selectedValue = null;
      } else {
        this.selectedValue = e;
      }
    },
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (index === "creationDate") {
          let dateA = new Date(this.getDate(a[index]));
          let dateB = new Date(this.getDate(b[index]));
          if (!isDesc) {
            return dateA < dateB ? -1 : 1;
          } else {
            return dateB < dateA ? -1 : 1;
          }
        } else {
          if (!isDesc) {
            return a[index] < b[index] ? -1 : 1;
          } else {
            return b[index] < a[index] ? -1 : 1;
          }
        }
      });
      return items;
    },
    getDate(d) {
      var day, month, year;

      let result = String(d).match("[0-9]{2}([-/ .])[0-9]{2}[-/ .][0-9]{4}");
      if (null != result) {
        let dateSplitted = result[0].split(result[1]);
        day = dateSplitted[0];
        month = dateSplitted[1];
        year = dateSplitted[2];
      }
      result = String(d).match("[0-9]{4}([-/ .])[0-9]{2}[-/ .][0-9]{2}");
      if (null != result) {
        let dateSplitted = result[0].split(result[1]);
        day = dateSplitted[2];
        month = dateSplitted[1];
        year = dateSplitted[0];
      }

      if (month > 12) {
        let aux = day;
        day = month;
        month = aux;
      }

      return year + "/" + month + "/" + day;
    },
    changeSort(column) {
      this.selectedValue = null;
      (this.selectRow = []), (this.additional_grouped = []);
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
        this.additional_grouped[0] = this.selectedValue;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
        this.additional_grouped[0] = this.selectedValue;
      }
    },
    refresh() {
      this.getComissionReport();
    },
    getComissionReport() {
      this.$store.dispatch("getCommissionsReport", this.filters);
    },
    search() {
      this.$store.dispatch("getCommissionsReport", this.filters);
    },
    limpiar() {
      this.filters = this.emptyFilters();
      this.applyDefaultPayDates();
      this.$store.dispatch("getCommissionsReport", this.filters);
    }
  },
  watch: {
    loadingCommission(val) {
      if (val) {
        this.$root.$emit(
          "showLoading",
          "Cargando información, por favor espere..."
        );
      } else {
        this.$root.$emit("hideLoading");
      }
    },
    agency(val) {
      this.$store.dispatch("getCommissionsReport", this.filters);
    }
  },
  components: {
    LiquidationComissionList
  },
  data() {
    return {
      selectedValue: null,
      selectRow: [],
      additional_grouped: [],
      searchValue: "",
      matches: [],
      pagination: {
        sortBy: "creationDate"
      },
      selected: [],
      filters: {
        agente: "",
        agencia: "0",
        estado: "0",
        fechaInicio: null,
        fechaFin: null,
        liquidacion: null,
        recibo: null,
        poliza: null,
        sistema: null,
        identificacion: null,
        contrato: null,
        buscar: ""
      }
    };
  }
};
</script>

<style scoped>
.liquidation-report-filters .liquidation-report-actions {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-wrap: wrap;
}

.liquidation-report-actions-inner {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;
}

.liquidation-report-buscar {
  max-width: 220px;
  min-width: 140px;
  flex: 1 1 auto;
  margin-right: 8px;
  margin-bottom: 0;
}

.liquidation-report-btn {
  min-height: 36px;
  margin-bottom: 2px;
  margin-left: 4px;
  text-transform: uppercase;
  font-weight: 500;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}
</style>
